import { BodyText, Skeleton } from "@/components/ui";

export const EditFileSkeleton = () => {
  return (
    <div
      className="flex flex-col rounded transition-colors gap-2"
      data-testid="edit-file-skeleton"
    >
      <Skeleton className="h-5 w-1/2 mt-3" />
      <div className="flex flex-row gap-3">
        <div className="w-40">
          <BodyText size="sm" bold>
            Category
          </BodyText>
          <Skeleton className="h-8" />
        </div>
        <div className="w-40">
          <BodyText size="sm" bold>
            EOC
          </BodyText>
          <Skeleton className="h-8" />
        </div>
      </div>
    </div>
  );
};
